import { useFormat } from 'helpers/hooks/useFormat';
import { useParams } from 'next/navigation';
import React from 'react';
import { Category } from 'shared/types/product/Category';

interface CategoryMenuProps {
  categories: Category[];
  activeCategory: Category;
}

const SidebarFooter: React.FC<CategoryMenuProps> = ({ categories, activeCategory }) => {
  const { locale } = useParams();
  const { formatMessage: formatMessagePadi } = useFormat({ name: 'padi' });
  const padiBlueLink = 'text-padi-blue hover:text-padi-blue-darker';

  return (
    <div>
      <div className="pb-20">
        <h3 className="mb-10 text-base font-bold">
          {formatMessagePadi({
            id: 'padiClub',
            defaultMessage: 'PADI Club',
          })}
        </h3>
        <ul role="list" className="space-y-4 text-sm text-gray-900">
          <li className="pb-5">
            <a href={`/${locale}/padi-club/`} className={padiBlueLink}>
              {formatMessagePadi({
                id: 'learnAboutPadiClub',
                defaultMessage: 'Learn about PADI Club',
              })}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SidebarFooter;
